/**
 * date-fns locale helper
 *
 * Wraps date-fns formatters with the active i18n locale. Without this,
 * `formatDistanceToNow(date, { addSuffix: true })` always returns English
 * ("3 days ago") which renders backwards inside an RTL Arabic page
 * ("day ago 3" / "days ago 3"). Pass the locale returned by `getDateFnsLocale()`
 * to every relative-time or named-token formatter call site.
 *
 * Usage:
 *   import { formatDistanceToNow } from 'date-fns';
 *   import { getDateFnsLocale } from '@/lib/dateLocale';
 *   formatDistanceToNow(date, { addSuffix: true, locale: getDateFnsLocale() });
 */
import i18n from '@/lib/i18n';
import { ar } from 'date-fns/locale/ar';
import { enUS } from 'date-fns/locale/en-US';
import type { Locale } from 'date-fns';

export function getDateFnsLocale(): Locale {
    const lang = i18n.language || 'en';
    if (lang.startsWith('ar')) return ar;
    return enUS;
}
